import { getCurrentLang } from 'react-redux-app/lib/modules/i18n/selectors';


export const getLoginUrl = (state, lang) => {
  const l = lang || getCurrentLang(state);
  return `/${l ? (`${l}/`) : ''}`;
};
